import { render, staticRenderFns } from "./flooter.vue?vue&type=template&id=3d55a79e&scoped=true"
import script from "./flooter.vue?vue&type=script&lang=js"
export * from "./flooter.vue?vue&type=script&lang=js"
import style0 from "./flooter.vue?vue&type=style&index=0&id=3d55a79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55a79e",
  null
  
)

export default component.exports